<template>
  <ion-page>
    <ion-content :class="[isMobile ? 'main-background' : 'liga-web-background']" :fullscreen="true" slot="fixed"
      :scroll-y="false">
      <h1 class="header-title ion-text-center white-bold">Пользователи</h1>
      <ion-item class="user-item-total">
        <ion-label slot="start">Всего пользователей:</ion-label>
        <ion-label slot="end">{{ totalItems }}</ion-label>
        <ion-button v-on:click="requestUsers()" class="bg-transparent fab-icon" slot="end">
          <ion-icon :icon="refreshOutline"></ion-icon>
        </ion-button>
      </ion-item>
      <div class="sync-button">
        <!-- <ion-button @click="confirmSync()">Синхронизация</ion-button> -->
        <ion-button @click="openUserGroupsSelector()">Группы прав</ion-button>
      </div>
      <ion-searchbar class="user-search" placeholder="Поиск" inputmode="text" type="text"
        @ionInput="onSearchChange($event)" :debounce="500"></ion-searchbar>
      <ion-item class="filter-field-clear-button" lines="none">
        <ion-item class="filter-field" lines="none">
          <ion-select label="Группы прав" v-model="authoritiesFilter" :multiple="true" placeholder="Не выбрано" cancel-text="Отмена"
            :interface-options="customSelectOptions">
            <ion-select-option v-for="authority in allAuthorities" :key="authority.name" :value="authority.name">{{
              authority.description }}</ion-select-option>
          </ion-select>
        </ion-item>
        <ion-icon slot="end" :icon="closeOutline" @click="clearFilter('authorities')"></ion-icon>
      </ion-item>
      <ion-content class="bg-transparent">
        <ion-list v-show="totalItems > 0" class="bg-transparent" lines="none">
          <ion-item v-for="(user, idx) in users" :key="idx" lines="none" class="user-item" v-show="filterUsers(user)"
            @click="openUserSettings(user)">
            <ion-label class="ion-margin-start">
              <p class="user-name">{{ user.lastName }} {{ user.firstName }}</p>
              <p class="user-email">{{ user.email }}</p>
            </ion-label>
            <ion-button v-on:click="setActive(user, false)" color="success" v-show="user.activated">
              <ion-label class="button-label">Активный</ion-label>
              <ion-icon slot="end" :icon="checkmarkOutline" class="button-icon"></ion-icon>
            </ion-button>
            <ion-button v-on:click="setActive(user, true)" color="danger" v-show="!user.activated">
              <ion-label class="button-label">Неактивный</ion-label>
              <ion-icon :icon="closeOutline" class="button-icon"></ion-icon>
            </ion-button>
          </ion-item>
          <ion-item class="fake-footer bg-transparent" lines="none"></ion-item>
        </ion-list>
      </ion-content>

      <ion-modal :is-open="showUserSettings" :breakpoints="[0, 1]" :initialBreakpoint="1"
        @ionModalDidDismiss="showUserSettings = false" @didDissmiss="closeUserSettings()">
        <ion-content class="bg-transparent modal-background">
          <ion-header class="user-settings-header">
            <ion-toolbar>
              <ion-title class="user-settings-header-title">{{ selectedUser[0].firstName }}
                {{ selectedUser[0].lastName }}</ion-title>
              <ion-buttons slot="end">
                <ion-button @click="closeUserSettings()" slot="end" class="user-settings-header-button">
                  <ion-icon :icon="closeOutline" slot="icon-only"></ion-icon>
                </ion-button>
              </ion-buttons>
            </ion-toolbar>
          </ion-header>
          <ion-item class="common-field">
            <ion-label slot="start">Логин</ion-label>
            <ion-label slot="end">{{ selectedUser[0].login }}</ion-label>
          </ion-item>
          <ion-item class="common-field">
            <ion-label slot="start">E-Mail</ion-label>
            <ion-label slot="end">{{ selectedUser[0].email }}</ion-label>
          </ion-item>
          <ion-accordion-group class="bg-transparent">
            <ion-accordion>
              <ion-item slot="header" class="role-header">
                <ion-label>Группы прав</ion-label>
              </ion-item>

              <ion-list slot="content" class="bg-transparent role-list" lines="none">
                <ion-item class="role-item add-role-button" v-show="commonAuthorities.length > 0">
                  <ion-select label="Добавить" :multiple="true" cancel-text="Отмена" @ionChange="onCommonAuthoritiesChanged($event)"
                    :interface-options="customSelectOptions">
                    <ion-select-option v-for="authority in commonAuthorities" :key="authority.name"
                      :value="authority.name">{{ authority.description }}</ion-select-option>
                  </ion-select>
                </ion-item>
                <ion-item-sliding v-for="authority in selectedUserAuthorities" :key="authority.name">
                  <ion-item v-show="authority.groupId == 1" class="role-item">
                    <ion-label>{{ authority.description }}</ion-label>
                  </ion-item>
                  <ion-item-options side="end">
                    <ion-item-option color="danger" @click="removeAuthority(authority)">Удалить</ion-item-option>
                  </ion-item-options>
                </ion-item-sliding>
              </ion-list>
            </ion-accordion>

            <ion-accordion>
              <ion-item slot="header" class="role-header">
                <ion-label>Допуск к программам</ion-label>
              </ion-item>

              <ion-list slot="content" class="bg-transparent role-list" lines="none">
                <ion-item class="role-item add-role-button" v-show="programAuthorities.length > 0">
                  <ion-select label="Добавить" :multiple="true" cancel-text="Отмена" @ionChange="onProgramAuthoritiesChanged($event)"
                    :interface-options="customSelectOptions">
                    <ion-select-option v-for="authority in programAuthorities" :key="authority.name"
                      :value="authority.name">{{ authority.description }}</ion-select-option>
                  </ion-select>
                </ion-item>
                <ion-item-sliding v-for="authority in selectedUserAuthorities" :key="authority.name">
                  <ion-item v-show="authority.groupId == 2" class="role-item">
                    <ion-label>{{ authority.description }}</ion-label>
                  </ion-item>
                  <ion-item-options side="end">
                    <ion-item-option color="danger" @click="removeAuthority(authority)">Удалить</ion-item-option>
                  </ion-item-options>
                </ion-item-sliding>
              </ion-list>
            </ion-accordion>

            <ion-accordion>
              <ion-item slot="header" class="role-header">
                <ion-label>Допуск к отдельным релизам</ion-label>
              </ion-item>

              <ion-list slot="content" class="bg-transparent role-list" lines="none">
                <ion-item class="role-item add-role-button" v-show="releaseAuthorities.length > 0">
                  <ion-select label="Добавить" :multiple="true" cancel-text="Отмена" @ionChange="onReleaseAuthoritiesChanged($event)"
                    :interface-options="customSelectOptions">
                    <ion-select-option v-for="release in releaseAuthorities" :key="release.id" :value="release">{{
                      release.program ? release.program.programName : '' }}
                      {{ release.releaseName }}</ion-select-option>
                  </ion-select>
                </ion-item>
                <ion-item-sliding v-for="release in selectedUserReleases" :key="release.id">
                  <ion-item class="role-item">
                    <ion-label>{{ release.program ? release.program.programName : '' }}
                      {{ release.releaseName }}</ion-label>
                  </ion-item>
                  <ion-item-options side="end">
                    <ion-item-option color="danger" @click="removeReleaseAuthority(release)">Удалить</ion-item-option>
                  </ion-item-options>
                </ion-item-sliding>
              </ion-list>
            </ion-accordion>
          </ion-accordion-group>
        </ion-content>
      </ion-modal>

      <ion-modal :can-dismiss="true" @didDismiss="showUserGroups = false" :is-open="showUserGroups"
        class="user-groups-modal">
        <div class="user-groups-card-container bg-transparent">
          <ion-card>
            <ion-card-header mode="ios">
              <ion-card-title>Добавление доступа</ion-card-title>
            </ion-card-header>
            <ion-card-content>
              <div class="user-groups-select-area">
                <ion-label @click="showAuthoritiesSelector = true">Нажмите для выбора группы прав</ion-label>
                <div class="chip-area">
                  <ion-chip v-show="selectedAuthorities.length > 0" v-for="authority in selectedAuthorities"
                    :key="authority.name" color="primary" mode="ios" :outline="true" @click="
                      removeSelectedAuthorities(
                        authority,
                        selectedAuthorities,
                        'name'
                      )
                      ">
                    <ion-label>{{ authority.description }}</ion-label>
                    <ion-icon :icon="closeOutline"></ion-icon>
                  </ion-chip>
                </div>
              </div>
              <div class="user-groups-select-area">
                <ion-label @click="showReleasesSelector = true">Нажмите для выбора релиза</ion-label>
                <div class="chip-area">
                  <ion-chip v-show="selectedReleases.length > 0" v-for="release in selectedReleases" :key="release.id"
                    color="primary" mode="ios" :outline="true" @click="
                      removeSelectedReleases(release, selectedReleases, 'id')
                      ">
                    <ion-label>{{ release.program ? release.program.programName : '' }}
                      {{ release.releaseName }}</ion-label>
                    <ion-icon :icon="closeOutline"></ion-icon>
                  </ion-chip>
                </div>
              </div>
              <div class="user-groups-select-area">
                <ion-label @click="showUsersSelector = true">Нажмите для выбора пользователей</ion-label>
                <div class="chip-area">
                  <ion-chip v-show="selectedUsers.length > 0" v-for="user in selectedUsers" :key="user.id" color="primary"
                    mode="ios" :outline="true" @click="removeSelectedUsers(user, selectedUsers, 'id')">
                    <ion-label>{{ user.lastName }} {{ user.firstName }}</ion-label>
                    <ion-icon :icon="closeOutline"></ion-icon>
                  </ion-chip>
                </div>
              </div>
            </ion-card-content>
            <div class="user-groups-btn-container">
              <ion-button @click="acceptUserGroups()" class="user-groups-accept-button">
                Сохранить
              </ion-button>
              <ion-button @click="dismissUserGroups()"> Отмена </ion-button>
            </div>
          </ion-card>
        </div>
      </ion-modal>

      <ion-modal :is-open="showAuthoritiesSelector" class="user-groups-modal"
        @ionModalDidDismiss="showAuthoritiesSelector = false">
        <div class="user-groups-card-container bg-transparent">
          <ion-card>
            <ion-card-header mode="ios">
              <ion-card-title>Выбор группы прав</ion-card-title>
            </ion-card-header>
            <ion-searchbar class="user-search" placeholder="Поиск" inputmode="text" type="text"
              @ionInput="addAuthoritiesFilter($event)" :debounce="500"></ion-searchbar>
            <ion-card-content class="list-selector-content">
              <ion-list>
                <ion-item :class="[
                  isSelectedByKey(authority, selectedAuthorities, 'name')
                    ? 'selected-item'
                    : 'bg-transparent',
                ]" @click="
  isSelectedByKey(authority, selectedAuthorities, 'name')
    ? removeSelectedAuthorities(
      authority,
      selectedAuthorities,
      'name'
    )
    : addSelection(authority, selectedAuthorities)
  " v-show="filterAuthorities(authority)" v-for="authority in allAuthorities" :key="authority.name"
                  :value="authority.name">{{ authority.description }}</ion-item>
              </ion-list>
            </ion-card-content>
            <div class="user-groups-btn-container">
              <ion-button @click="approveAuthoritiesSelector()" class="user-groups-accept-button">
                Добавить
                {{
                  selectedAuthorities.length > 0
                  ? `(${selectedAuthorities.length})`
                  : ""
                }}
              </ion-button>
              <ion-button @click="dismissAuthoritiesSelector()">
                Отмена
              </ion-button>
            </div>
          </ion-card>
        </div>
      </ion-modal>

      <ion-modal :is-open="showReleasesSelector" class="user-groups-modal"
        @ionModalDidDismiss="showReleasesSelector = false">
        <div class="user-groups-card-container bg-transparent">
          <ion-card>
            <ion-card-header mode="ios">
              <ion-card-title>Выбор релиза</ion-card-title>
            </ion-card-header>
            <ion-searchbar class="user-search" placeholder="Поиск" inputmode="text" type="text"
              @ionChange="addReleasesFilter($event)" :debounce="500"></ion-searchbar>
            <ion-card-content class="list-selector-content">
              <ion-list>
                <ion-item :class="[
                  isSelectedByKey(release, selectedReleases, 'id')
                    ? 'selected-item'
                    : 'bg-transparent',
                ]" @click="
  isSelectedByKey(release, selectedReleases, 'id')
    ? removeSelectedReleases(release, selectedReleases, 'id')
    : addSelection(release, selectedReleases)
  " v-show="filterReleases(release)" v-for="release in releaseAuthorities" :key="release.id" :value="release">{{
    release.program ? release.program.programName : '' }}
                  {{ release.releaseName }}</ion-item>
              </ion-list>
            </ion-card-content>
            <div class="user-groups-btn-container">
              <ion-button @click="approveReleasesSelector()" class="user-groups-accept-button">
                Добавить
                {{
                  selectedReleases.length > 0
                  ? `(${selectedReleases.length})`
                  : ""
                }}
              </ion-button>
              <ion-button @click="dismissReleasesSelector()">
                Отмена
              </ion-button>
            </div>
          </ion-card>
        </div>
      </ion-modal>

      <ion-modal :is-open="showUsersSelector" class="user-groups-modal" @ionModalDidDismiss="showUsersSelector = false">
        <div class="user-groups-card-container bg-transparent">
          <ion-card>
            <ion-card-header mode="ios">
              <ion-card-title>Выбор пользователей</ion-card-title>
            </ion-card-header>
            <ion-searchbar class="user-search" placeholder="Поиск" inputmode="text" type="text"
              @ionInput="onSearchChange($event)" :debounce="500"></ion-searchbar>
            <ion-card-content class="list-selector-content">
              <ion-list>
                <ion-item :class="[
                  isSelectedByKey(user, selectedUsers, 'id')
                    ? 'selected-item'
                    : 'bg-transparent',
                ]" @click="
  isSelectedByKey(user, selectedUsers, 'id')
    ? removeSelectedUsers(user, selectedUsers, 'id')
    : addSelection(user, selectedUsers)
  " v-show="filterUsers(user)" v-for="user in users" :key="user.id" :value="user">{{ user.lastName }}
                  {{ user.firstName }}</ion-item>
              </ion-list>
            </ion-card-content>
            <div class="user-groups-btn-container">
              <ion-button @click="approveUsersSelector()" class="user-groups-accept-button">
                Добавить
                {{
                  selectedUsers.length > 0 ? `(${selectedUsers.length})` : ""
                }}
              </ion-button>
              <ion-button @click="dismissUsersSelector()"> Отмена </ion-button>
            </div>
          </ion-card>
        </div>
      </ion-modal>
    </ion-content>
  </ion-page>
</template>

<script lang="ts">
import { Authority } from "@/model/authority.model";
import { GlobalContext } from "@/model/globalcontext.model";
import { ProgramRelease } from "@/model/programrelease.model";
import { User } from "@/model/user.model";
import buildPaginationQueryOpts from "@/utils/sorts";
import { CapacitorHttp } from "@capacitor/core";
import { Preferences } from "@capacitor/preferences";
import {
    IonAccordion,
    IonAccordionGroup,
    IonButton,
    IonButtons,
    IonCard,
    IonCardContent,
    IonCardHeader,
    IonCardTitle,
    IonChip,
    IonContent,
    IonHeader,
    IonIcon,
    IonItem,
    IonItemOption,
    IonItemOptions,
    IonItemSliding,
    IonLabel,
    IonList,
    IonModal,
    IonPage,
    IonSearchbar,
    IonSelect,
    IonSelectOption,
    IonTitle,
    IonToolbar,
    alertController,
} from "@ionic/vue";
import axios from "axios";
import {
    arrowForward,
    checkmarkOutline,
    closeOutline,
    refreshOutline,
} from "ionicons/icons";
import { defineComponent, inject } from "vue";

export default defineComponent({
  name: "Users",
  components: {
    IonContent,
    IonHeader,
    IonToolbar,
    IonTitle,
    IonPage,
    IonList,
    IonItem,
    IonItemSliding,
    IonItemOptions,
    IonItemOption,
    IonLabel,
    IonButtons,
    IonButton,
    IonSearchbar,
    IonIcon,
    IonSelect,
    IonSelectOption,
    IonModal,
    IonAccordionGroup,
    IonAccordion,
    IonCard,
    IonCardContent,
    IonCardHeader,
    IonCardTitle,
    IonChip,
  },

  setup() {
    const customSelectOptions: any = {
      cssClass: "role-selector",
    };
    const globalContext = inject("globalContext") as GlobalContext;
    const isMobile = globalContext.isMobile;

    return {
      checkmarkOutline,
      closeOutline,
      refreshOutline,
      customSelectOptions,
      isMobile,
      arrowForward,
    };
  },

  data() {
    return {
      notificationsState: false,
      totalItems: 0,
      users: Array<User>(),
      searchBy: ".",
      searchAuthoritiesBy: ".",
      searchReleasesBy: ".",
      allAuthorities: Array<Authority>(),
      authoritiesFilter: Array<string>(),
      showUserSettings: false,
      selectedUser: Array<User>(),
      selectedUserReleases: Array<ProgramRelease>(),
      allReleases: Array<ProgramRelease>(),

      releaseAuthoritiesAdded: Array<number>(),
      showUserGroups: false,

      showAuthoritiesSelector: false,
      selectedAuthorities: Array<Authority>(),

      showReleasesSelector: false,
      selectedReleases: Array<ProgramRelease>(),

      showUsersSelector: false,
      selectedUsers: Array<User>(),
    };
  },

  computed: {
    selectedUserAuthorities(): Array<Authority> {
      const result = new Array<Authority>();
      if (this.selectedUser.length > 0) {
        if (this.selectedUser[0].authorities) {
          this.selectedUser[0].authorities.forEach((a) => {
            const authority = this.getAuthorityByName(a);
            result.push(authority);
          });
        }
      }
      result.sort(function (a, b) {
        const keyA = a.description,
          keyB = b.description;
        if (keyA < keyB) return -1;
        if (keyA > keyB) return 1;
        return 0;
      });
      return result;
    },

    commonAuthorities(): Array<Authority> {
      if (!this.allAuthorities) return new Array<Authority>();

      return this.allAuthorities.filter((a) => {
        const foundSelected = this.selectedUserAuthorities.find((ua) => {
          return ua.name === a.name;
        });

        return a.groupId === 1 && foundSelected === undefined;
      });
    },

    programAuthorities(): Array<Authority> {
      if (!this.allAuthorities) return new Array<Authority>();

      return this.allAuthorities.filter((a) => {
        const foundSelected = this.selectedUserAuthorities.find((ua) => {
          return ua.name === a.name;
        });

        return a.groupId === 2 && foundSelected === undefined;
      });
    },

    releaseAuthorities(): Array<ProgramRelease> {
      if (!this.allReleases) return new Array<ProgramRelease>();

      return this.allReleases
        .filter((r) => {
          const foundSelected = this.selectedUserReleases.find((ur) => {
            return ur.id === r.id;
          });

          return foundSelected === undefined;
        })
        .sort((a, b) => {
          const aParts = (a.releaseName || "").split(" ");
          const bParts = (b.releaseName || "").split(" ");
          const aName = aParts.slice(0, aParts.length - 1).join(" ");
          const aNum = aParts[aParts.length - 1];
          const bName = bParts.slice(0, bParts.length - 1).join(" ");
          const bNum = bParts[bParts.length - 1];

          return aNum.localeCompare(bNum) && aName.localeCompare(bName);
        })
        .reverse();
    },
  },

  mounted() {
    this.requestUsers();
    this.getAllAuthorities();
    this.getAllReleases();
  },

  methods: {
    onSearchChange(ev: any) {
      if (ev.detail.value.trim() === "") {
        this.searchBy = ".";
      } else {
        this.searchBy = ev.detail.value.trim();
      }
    },

    acceptUserGroups() {
      this.showUserGroups = false;

      this.saveUserGroupsAuthorities();
      this.saveUserGroupsReleases();
    },

    dismissUserGroups() {
      this.showUserGroups = false;
      this.selectedAuthorities = [];
      this.selectedReleases = [];
      this.selectedUsers = [];
    },

    addAuthoritiesFilter(ev: any) {
      if (ev.detail.value.trim() === "") {
        this.searchAuthoritiesBy = ".";
      } else {
        this.searchAuthoritiesBy = ev.detail.value.trim();
      }
    },

    addReleasesFilter(ev: any) {
      if (ev.detail.value.trim() === "") {
        this.searchReleasesBy = ".";
      } else {
        this.searchReleasesBy = ev.detail.value.trim();
      }
    },

    filterUsers(user: User) {
      if (!user || !user.lastName || !user.firstName) return true;

      const searchByRegExp = new RegExp(this.searchBy.toLowerCase());
      let result = searchByRegExp.test(
        user.lastName.toLowerCase() + user.firstName.toLowerCase()
      );

      if (result && this.authoritiesFilter.length > 0) {
        result =
          typeof user.authorities !== "undefined" &&
          user.authorities.some((authority) => {
            return this.authoritiesFilter.includes(authority);
          });
      }

      return result;
    },

    filterAuthorities(authority: Authority) {
      if (!authority || !authority.description) return true;

      const searchByRegExp = new RegExp(this.searchAuthoritiesBy.toLowerCase());
      return searchByRegExp.test(authority.description.toLowerCase());
    },

    filterReleases(release: any) {
      if (!release || !release.releaseName) return true;

      const searchByRegExp = new RegExp(this.searchReleasesBy.toLowerCase());
      return searchByRegExp.test(
        `${release.program ? release.program.programName : ''} ${release.releaseName}`.toLowerCase()
      );
    },

    clearFilter(filterName: string) {
      if ("authorities" === filterName) {
        this.authoritiesFilter = new Array<string>();
      }
    },

    addSelection(item: any, list: Array<any>) {
      list.push(item);
    },

    removeSelection(item: any, list: Array<any>, byKey: any) {
      return list.filter((i) => {
        return i[byKey] !== item[byKey];
      });
    },

    removeSelectedAuthorities(item: any, list: Array<any>, byKey: any) {
      this.selectedAuthorities = this.removeSelection(item, list, byKey);
    },

    removeSelectedReleases(item: any, list: Array<any>, byKey: any) {
      this.selectedReleases = this.removeSelection(item, list, byKey);
    },

    removeSelectedUsers(item: any, list: Array<any>, byKey: any) {
      this.selectedUsers = this.removeSelection(item, list, byKey);
    },

    isSelectedByKey(item: any, list: Array<any>, byKey: any) {
      return (
        undefined !==
        list.find((i) => {
          return i[byKey] === item[byKey];
        })
      );
    },

    dismissAuthoritiesSelector() {
      this.showAuthoritiesSelector = false;
      this.selectedAuthorities = new Array<Authority>();
    },

    approveAuthoritiesSelector() {
      this.showAuthoritiesSelector = false;
    },

    dismissReleasesSelector() {
      this.showReleasesSelector = false;
      this.selectedReleases = new Array<ProgramRelease>();
    },

    approveReleasesSelector() {
      this.showReleasesSelector = false;
    },

    dismissUsersSelector() {
      this.showUsersSelector = false;
      this.selectedUsers = new Array<User>();
    },

    approveUsersSelector() {
      this.showUsersSelector = false;
    },

    async requestUsers() {
      const req = {
        page: 0,
        size: 1000,
        sort: ["id,desc"],
      };

      if (this.isMobile) {
        const tokenQuery = await Preferences.get({ key: "jwt" });
        const token = tokenQuery.value;

        const options = {
          url: `${process.env.VUE_APP_API_URL
            }api/admin/users?${buildPaginationQueryOpts(req)}`,
          headers: { Authorization: `Bearer ${token}` },
          readTimeout: 60000,
        };

        await CapacitorHttp.get(options)
          .then((response) => {
            this.users = response.data;
            this.totalItems = Number(response.headers["X-Total-Count"] || response.headers["x-total-count"]);
            if (!this.totalItems || this.totalItems < 1) {
              this.totalItems = Number(response.headers["X-Total-Count"] || response.headers["x-total-count"]);
            }
            if (!this.totalItems || this.totalItems < 1) {
              this.totalItems = this.users.length;
            }
          })
          .catch((ex) => {
            console.log("error loading users", ex);
          });
      } else {
        await axios
          .get(`api/admin/users?${buildPaginationQueryOpts(req)}`)
          .then((response) => {
            this.users = response.data;
            this.totalItems = Number(response.headers["X-Total-Count"] || response.headers["x-total-count"]);
          })
          .catch(() => {
            this.$router.replace("/badconnection");
          });
      }
    },

    async setActive(user: User, active: boolean) {
      user.activated = active;
      if (this.isMobile) {
        const tokenQuery = await Preferences.get({ key: "jwt" });
        const token = tokenQuery.value;

        const data = {
          id: user.id,
          login: user.login,
          email: user.email,
          activated: user.activated,
        };

        const options = {
          url: `${process.env.VUE_APP_API_URL}api/admin/users/activate`,
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          readTimeout: 60000,
          data: data,
        };

        await CapacitorHttp.post(options).catch(() => {
          this.$router.replace("/badconnection");
        });
      } else {
        axios.put("api/admin/users", user).catch(() => {
          this.$router.replace("/badconnection");
        });
      }
    },

    async getAllAuthorities() {
      if (this.isMobile) {
        const tokenQuery = await Preferences.get({ key: "jwt" });
        const token = tokenQuery.value;

        const options = {
          url: `${process.env.VUE_APP_API_URL}api/authorities-full`,
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          readTimeout: 60000,
        };

        await CapacitorHttp.get(options)
          .then((response) => {
            this.allAuthorities = response.data;
            this.allAuthorities.sort(function (a, b) {
              const keyA = a.description,
                keyB = b.description;
              if (keyA < keyB) return -1;
              if (keyA > keyB) return 1;
              return 0;
            });
          })
          .catch((ex) => {
            console.log("error loading authorities", ex);
          });
      } else {
        axios
          .get("api/authorities-full")
          .then((response) => {
            this.allAuthorities = response.data;
            this.allAuthorities.sort(function (a, b) {
              const keyA = a.description,
                keyB = b.description;
              if (keyA < keyB) return -1;
              if (keyA > keyB) return 1;
              return 0;
            });
          })
          .catch(() => {
            this.$router.replace("/badconnection");
          });
      }
    },

    async getAllReleases() {
      const tokenQuery = await Preferences.get({ key: "jwt" });
        const token = tokenQuery.value;

        const options = {
          url: `${process.env.VUE_APP_API_URL}api/releases`,
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          readTimeout: 60000,
        };

        await CapacitorHttp.get(options)
          .then((response) => {
            this.allReleases = response.data;
            // this.allReleases.sort(function (a, b) {
            //   const keyA =
            //     `${a.program.id > 0
            //       ? a.program.programName
            //       : ""
            //     } ${((a.releaseName && a.releaseName.length) || 0) < 2
            //       ? "0" + a.releaseName
            //       : a.releaseName
            //     }` || "",
            //     keyB =
            //       `${b.program.id > 0
            //         ? b.program.programName
            //         : ""
            //       } ${((b.releaseName && b.releaseName.length) || 0) < 2
            //         ? "0" + b.releaseName
            //         : b.releaseName
            //       }` || "";
            //   if (keyA < keyB) return -1;
            //   if (keyA > keyB) return 1;
            //   return 0;
            // });
          })
          .catch((ex) => {
            console.log("error loading releases", ex);
          });
    },

    async getUserReleases(user: User) {
      if (this.isMobile) {
        const tokenQuery = await Preferences.get({ key: "jwt" });
        const token = tokenQuery.value;

        const options = {
          url: `${process.env.VUE_APP_API_URL}api/user/releases/${user.id}`,
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          readTimeout: 60000,
        };

        await CapacitorHttp.get(options)
          .then((response) => {
            this.selectedUserReleases = response.data;
            this.selectedUserReleases.sort(function (a, b) {
              const keyA =
                `${a.program.id > 0
                  ? a.program.programName
                  : ""
                } ${((a.releaseName && a.releaseName.length) || 0) < 2
                  ? "0" + a.releaseName
                  : a.releaseName
                }` || "",
                keyB =
                  `${b.program.id > 0
                    ? b.program.programName
                    : ""
                  } ${((b.releaseName && b.releaseName.length) || 0) < 2
                    ? "0" + b.releaseName
                    : b.releaseName
                  }` || "";
              if (keyA < keyB) return -1;
              if (keyA > keyB) return 1;
              return 0;
            });
          })
          .catch((ex) => {
            console.log("error loading user releases", ex);
          });
      } else {
        axios
          .get(`api/user/releases/${user.id}`)
          .then((response) => {
            this.selectedUserReleases = response.data;
            this.selectedUserReleases.sort(function (a, b) {
              const keyA =
                `${a.program.id > 0
                  ? a.program.programName
                  : ""
                } ${((a.releaseName && a.releaseName.length) || 0) < 2
                  ? "0" + a.releaseName
                  : a.releaseName
                }` || "",
                keyB =
                  `${b.program.id > 0
                    ? b.program.programName
                    : ""
                  } ${((b.releaseName && b.releaseName.length) || 0) < 2
                    ? "0" + b.releaseName
                    : b.releaseName
                  }` || "";
              if (keyA < keyB) return -1;
              if (keyA > keyB) return 1;
              return 0;
            });
          })
          .catch(() => {
            this.$router.replace("/badconnection");
          });
      }
    },

    onCommonAuthoritiesChanged(event: any) {
      const currentUserAuthorities =
        this.selectedUser[0].authorities || new Array<string>();
      event.target.value.forEach((a: string) => {
        const found = currentUserAuthorities.find((ua) => {
          return ua === a;
        });

        if (found === undefined) {
          currentUserAuthorities.push(a);
        }
      });

      this.selectedUser[0].authorities = currentUserAuthorities;

      this.saveUserAuthorities(this.selectedUser[0]);
    },

    onProgramAuthoritiesChanged(event: any) {
      const currentUserAuthorities =
        this.selectedUser[0].authorities || new Array<string>();
      event.target.value.forEach((a: string) => {
        const found = currentUserAuthorities.find((ua) => {
          return ua === a;
        });

        if (found === undefined) {
          currentUserAuthorities.push(a);
        }
      });

      this.selectedUser[0].authorities = currentUserAuthorities;

      this.saveUserAuthorities(this.selectedUser[0]);
    },

    onReleaseAuthoritiesChanged(event: any) {
      event.target.value.forEach((release: ProgramRelease) => {
        const found = this.selectedUserReleases.find((userRelease) => {
          return userRelease.id === release.id;
        });

        if (found === undefined) {
          this.selectedUserReleases.push(release);
        }
      });

      this.selectedUser[0].releases = this.selectedUserReleases.map((r) => {
        return r.id || 0;
      });
      this.saveUserReleases(this.selectedUser[0]);
    },

    removeAuthority(authority: Authority) {
      const currentUserAuthorities =
        this.selectedUser[0].authorities || new Array<string>();
      this.selectedUser[0].authorities = currentUserAuthorities.filter((ua) => {
        return ua !== authority.name;
      });

      this.saveUserAuthorities(this.selectedUser[0]);
    },

    removeReleaseAuthority(release: ProgramRelease) {
      this.selectedUserReleases = this.selectedUserReleases.filter(
        (userRelease) => {
          return userRelease.id !== release.id;
        }
      );

      this.selectedUser[0].releases = this.selectedUserReleases.map((r) => {
        return r.id || 0;
      });
      this.saveUserReleases(this.selectedUser[0]);
    },

    saveUserGroupsAuthorities() {
      if (this.selectedUsers.length < 1 || this.selectedAuthorities.length < 1)
        return;

      this.selectedUsers.forEach((user) => {
        const currentAuthorities = user.authorities || new Array<string>();
        this.selectedAuthorities.forEach((sa) => {
          if (
            undefined ==
            currentAuthorities.find((ca) => {
              return ca === sa.name;
            })
          ) {
            currentAuthorities.push(sa.name);
          }
        });
        user.authorities = currentAuthorities;
        this.saveUserAuthorities(user);
      });
    },

    saveUserGroupsReleases() {
      if (this.selectedUsers.length < 1 || this.selectedReleases.length < 1)
        return;

      this.selectedUsers.forEach((user) => {
        const currentReleases = user.releases || new Array<number>();
        this.selectedReleases.forEach((sr) => {
          if (
            sr.id &&
            undefined ==
            currentReleases.find((cr) => {
              return cr === sr.id;
            })
          ) {
            currentReleases.push(sr.id);
          }
        });
        user.releases = currentReleases;
        this.saveUserReleases(user);
      });
    },

    async saveUserAuthorities(user: User) {
      if (this.isMobile) {
        const tokenQuery = await Preferences.get({ key: "jwt" });
        const token = tokenQuery.value;

        const options = {
          url: `${process.env.VUE_APP_API_URL}api/admin/users/authorities`,
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          readTimeout: 60000,
          data: JSON.stringify(user),
        };

        await CapacitorHttp.post(options).catch(() => {
          this.$router.replace("/badconnection");
        });
      } else {
        axios.post("api/admin/users/authorities", user).catch(() => {
          this.$router.replace("/badconnection");
        });
      }
    },

    async saveUserReleases(user: User) {
      if (this.isMobile) {
        const tokenQuery = await Preferences.get({ key: "jwt" });
        const token = tokenQuery.value;

        const options = {
          url: `${process.env.VUE_APP_API_URL}api/admin/users/releases`,
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          readTimeout: 60000,
          data: JSON.stringify(user),
        };

        await CapacitorHttp.post(options).catch(() => {
          this.$router.replace("/badconnection");
        });
      } else {
        axios.post("api/admin/users/releases", user).catch(() => {
          this.$router.replace("/badconnection");
        });
      }
    },

    getAuthorityByName(authorityName: string): Authority {
      const foundByName = this.allAuthorities.find((a) => {
        return a.name === authorityName;
      });
      if (typeof foundByName !== "undefined") {
        return foundByName;
      }

      return new Authority(authorityName);
    },

    openUserSettings(user: User) {
      this.showUserSettings = true;
      this.selectedUser = new Array<User>();
      this.selectedUser.push(user);
      this.getUserReleases(user);
    },

    closeUserSettings() {
      this.showUserSettings = false;
      this.requestUsers();
    },

    openUserGroupsSelector() {
      this.selectedUsers = [];
      this.selectedReleases = [];
      this.selectedAuthorities = [];
      this.showUserGroups = true;
    },

    async confirmSync() {
      const alert = await alertController.create({
        header: "Подтверждение!",
        message: `Внимание: будет выполнена синхронизация с внешней таблицей, что приведет к перезаписи данных приложения`,
        buttons: [
          {
            text: "Отмена",
            role: "cancel",
            cssClass: "secondary",
            id: "cancel-button",
          },
          {
            text: "Далее",
            id: "confirm-button",
            handler: () => {
              this.syncUsers();
            },
          },
        ],
      });
      return alert.present();
    },

    async syncUsers() {
      const tokenQuery = await Preferences.get({ key: "jwt" });
      const token = tokenQuery.value;

      const options = {
        url: `${process.env.VUE_APP_API_URL}api/google/sync-accounts`,
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        readTimeout: 60000,
      };

      await CapacitorHttp.post(options).catch(() => {
        this.$router.replace("/badconnection");
      });
    },
  },
});
</script>

<style scoped>
h1 {
  letter-spacing: 0.08em;
}

.button-icon {
  color: white;
}

.button-label {
  font-family: 'Montserrat',
    Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
  font-size: 0.8em;
  font-weight: bold;
  color: white;
}

.fab-icon {
  --color: var(--ion-color-orange);
  --background-activated: var(--ion-color-orange-tint);
}

.user-item-total {
  --background: rgba(67, 67, 67, 0.7);
  border-top: 1px solid #868686;
  border-bottom: 1px solid #868686;
  width: 100vw;
  margin-bottom: 20px;
  --min-height: 60px;
  color: white;
}

.user-item-total ion-label {
  font-family: 'NotoSans';
  font-weight: 500;
}

.user-item-total ion-button {
  --box-shadow: none;
  margin-bottom: 0.5em;
}

.user-item {
  --background: rgba(67, 67, 67, 0.7);
  border-top: 1px solid #868686;
  border-bottom: 1px solid #868686;
  margin-bottom: 10px;
  --min-height: 20px;
  color: white;
}

.user-name, .user-email {
  font-family: 'Montserrat';
  font-weight: 700;
  font-size: 1em;
  color: white;
}

.user-email {
  font-weight: 500;
  font-size: .8em;
  color: rgba(255, 255, 255, .8);
}

.user-search {
  --background: rgba(43, 43, 43, 0.8);
  --placeholder-opacity: 0.5;
  --color: white;
  --placeholder-color: white;
  --border-radius: 20px;
  font-family: 'Montserrat',
    Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
}

.fake-footer {
  height: 40vh;
}

.filter-field {
  width: 100%;
  color: white;
  --background-activated: black !important;
  --background: transparent;
}

.filter-field-clear-button {
  color: #8a8a8a !important;
  margin-bottom: 5px;
  --background: transparent;
  border-top: 1px solid #868686;
  border-bottom: 1px solid #868686;
}

.user-settings-header ion-toolbar {
  --background: var(--ion-color-dark);
}

.user-settings-header-title {
  color: var(--ion-color-orange);
  font-size: 1.5em;
}

.user-settings-header-button {
  color: var(--ion-color-orange) !important;
  --background-activated: transparent !important;
}

.user-settings-section-list {
  height: 50vh;
}

.user-settings-section-header {
  font-weight: bold;
  color: var(--ion-color-orange);
}

.user-settings-section-list ion-item {
  margin-bottom: 5px;
  border-top: 1px solid #434343;
  border-bottom: 1px solid #434343;
  --background: rgb(66, 66, 66);
  color: white;
}

.role-header {
  --background: rgb(66, 66, 66);
  --min-height: 80px;
  font-weight: bold;
  border: 1px solid #434343;
  font-size: 1.5em;
}

.role-item {
  --background: var(--ion-color-dark);
  color: rgb(226, 226, 226);
  --min-height: 60px;
  font-weight: bold;
  border-bottom: 1px solid #434343;
}

.role-list {
  background: var(--ion-color-dark);
}

.add-role-button {
  font-size: 1.3em;
  --background: rgba(134, 134, 134, 0.7) !important;
}

.modal-background {
  background: var(--ion-color-dark);
}

.common-field {
  --background: var(--ion-color-dark);
  color: white;
}

ion-item {
  color: white;
  --color-focused: white;
  --color-hover: white;
  --color-activated: #434343;
}

.sync-button {
  display: flex;
  justify-content: space-around;
  align-items: center;
}

.sync-button ion-button {
  --background: var(--ion-color-orange);
  --background-activated: var(--ion-color-orange-tint);
  /* width: 280px; */
  height: 50px;
  font-family: 'Montserrat',
    Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
  font-weight: bold;
  --border-radius: 14px;
}

.user-groups-modal {
  --background: rgba(67, 67, 67, 0.5) !important;
}

.user-groups-card-container {
  display: flex;
  justify-content: center;
  align-content: center;
  flex-flow: column;
}

.user-groups-card-container ion-card {
  padding: 20px;
  max-height: 90%;
  overflow: scroll;
  --background: var(--ion-color-dark) !important;
}

.user-groups-card-container ion-card-title {
  color: white;
  font-weight: bold;
  font-size: 1.8em;
  letter-spacing: 0.07em;
}

.user-groups-card-container ion-card-content {
  color: rgba(255, 255, 255, 0.5);
  font-weight: bold;
  font-size: 1em;
  letter-spacing: 0.07em;
}

.user-groups-card-container ion-item {
  --background: transparent;
  color: white !important;
}

.user-groups-card-container ion-item ion-icon {
  color: white !important;
  cursor: pointer;
}

.user-groups-btn-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.user-groups-btn-container ion-button {
  --background: transparent;
  --background-activated: var(--ion-color-orange-tint);
  width: 280px;
  height: 50px;
  font-family: 'Montserrat',
    Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
  font-weight: bold;
  --border-radius: 14px;
  --border-color: var(--ion-color-orange) !important;
  --border-style: solid !important;
  --border-width: 1px !important;
}

.user-groups-accept-button {
  --background: var(--ion-color-orange) !important;
}

.user-groups-select-area {
  min-height: 10%;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 15px;
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;
  margin-bottom: 20px;
  padding-top: 10px;
  padding-bottom: 10px;
}

.user-groups-select-area ion-label {
  color: rgba(255, 255, 255, 0.5);
}

.user-groups-select-area ion-chip {
  z-index: 100;
}

.chip-area {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  max-height: 15vh;
  overflow: scroll;
}

.selector-arrow {
  justify-self: end;
  align-self: center;
}

.list-selector-content {
  max-height: 40vh;
  overflow: scroll;
}

.list-selector-content ion-list {
  background: transparent !important;
}

.list-selector-content ion-item {
  --border-color: rgba(255, 255, 255, 0.1) !important;
  --border-radius: 5px;
}

.selected-item {
  --background: var(--ion-color-orange) !important;
}
</style>